export const FlashStatuses = ['success', 'info', 'warning', 'error'] as const;

export type FlashStatus = (typeof FlashStatuses)[number];

export type FlashMessage = {
  title: string;
  description?: string;
};

export type Flash = {
  [K in FlashStatus]?: FlashMessage;
};
